import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/rolls/chocolate rolls.png";
import BiscuitImg from "../../../assets/products/rolls/Chocolate-Roll.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 4,
  },
  {
    grams: 15,
  },
  {
    grams: 18,
  },
];

export default function ChocolateRollProduct() {
  return (
    <>
      <Helmet>
        <title>Chocolate Roll – BearBitz | Premium Biscuits & Rolls</title>
        <meta
          name="description"
          content="Explore BearBitz Chocolate Rolls — crispy rolled wafers filled with rich chocolate cream. View pack sizes and specs."
        />
        <meta
          name="keywords"
          content="Chocolate Roll, BearBitz Chocolate Roll"
        />
        <link rel="canonical" href="https://www.bearbitz.in/rolls/chocolateroll" />
        <meta property="og:title" content="Chocolate Roll – BearBitz" />
        <meta
          property="og:description"
          content="Crispy rolled wafer dessert filled with chocolate cream by BearBitz, export-quality."
        />
      </Helmet>

      <ProductTemplate
        productTitle="CHOCOLATE"
        productImage={BisImg}
        description="Rolled for Flavor, Baked for Crunch Delicious cylindrical wafer rolls packed with rich cream fillings, offering a delightful crunch with every bite. Available in various tempting flavors, they make for a premium snacking experience and a perfect pairing with beverages. Popular in gift packs and premium retail shelves across global markets."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#68171A"
        sectionBgColor="#FFC158"
        productBgcolor="#FFECCB"
        tableheadBgcolor="#68171A"
        tableBgcolor="#FFE7BE"
        footerBgcolor="#6A3E20"
      />
    </>
  );
}
